"use client";
import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { tabs, separator } from './styles.js';
import { ContentSwitcherTab } from './ContentSwitcherTab/ContentSwitcherTab.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { useHorizontalScroll, handleTabKeyDown } from '../Tabs/utils.web.js';
import { ThemeProvider } from 'styled-components';
import { Box } from '../Box/Box.web.js';

var _excluded = ["active", "items", "onTabChange", "stretchOnMobile", "color", "size", "variant", "activeIcon"];
function ContentSwitcher(props) {
  var active = props.active,
    items = props.items,
    onTabChange = props.onTabChange,
    stretchOnMobile = props.stretchOnMobile,
    color = props.color,
    sizeProp = props.size,
    variantProp = props.variant,
    activeIcon = props.activeIcon,
    rest = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var variant = variantProp || theme.variant;
  var wrapperRef = React.useRef(null);
  var _useHorizontalScroll = useHorizontalScroll(wrapperRef),
    scrolling = _useHorizontalScroll.scrolling,
    scrollEndLeft = _useHorizontalScroll.scrollEndLeft,
    scrollEndRight = _useHorizontalScroll.scrollEndRight,
    handleScrolling = _useHorizontalScroll.handleScrolling;
  var handleTabClick = React.useCallback(function (e, id) {
    e.preventDefault();
    onTabChange(id);
  }, [onTabChange]);

  // store refs to a map by item, used to focus next/previous on arrow nav
  var _React$useState = React.useState(new Map()),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    refMap = _React$useState2[0],
    setRefMap = _React$useState2[1];
  React.useEffect(function () {
    var map = new Map();
    items.forEach(function (item) {
      return map.set(item, /*#__PURE__*/React.createRef());
    });
    setRefMap(map);
  }, [items]);
  var size = variant === 'condensed' ? 's' : sizeProp !== null && sizeProp !== undefined ? sizeProp : theme.preferredComponentSize;
  var activeIndex = items.findIndex(function (i) {
    return i.id === active;
  });
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Box, _extends({
    "data-testid": "elemental-ContentSwitcher",
    position: "relative"
  }, rest), /*#__PURE__*/React.createElement(tabs, {
    role: "tablist",
    ref: wrapperRef,
    onScroll: handleScrolling,
    $count: items.length,
    $stretchOnMobile: stretchOnMobile,
    $scrollEndLeft: scrollEndLeft,
    $scrollEndRight: scrollEndRight,
    $scrolling: scrolling,
    $size: size,
    $variant: variant,
    $borderRadius: theme.borders.radius
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: item.id
    }, index > 0 && /*#__PURE__*/React.createElement(separator, {
      $visible: index - 1 === activeIndex || item.id === active
    }), /*#__PURE__*/React.createElement(ContentSwitcherTab, {
      item: item,
      isActive: item.id === active,
      onClick:
      // can't get generics work with useCallback, thus manually typed
      handleTabClick,
      onKeyDown: function onKeyDown(e) {
        return handleTabKeyDown(e, item, items, onTabChange, refMap);
      },
      color: color || theme.contentSwitcher.web.color,
      stretchOnMobile: stretchOnMobile,
      "data-testid": "elemental-ContentSwitcher-".concat(item.id),
      ref: refMap.get(item),
      size: size,
      variant: variant,
      activeIcon: activeIcon
    }));
  }))));
}

export { ContentSwitcher };
